
import React, { useState, useRef, useEffect } from "react";
import Modal from "react-modal";
import { useTranslation } from 'react-i18next';

const OrganisationalPolicyModal = ({
    isOpen,
    onRequestClose,
}) => {

    const { t } = useTranslation();

    const closeModal = () => {
        onRequestClose();
    }

    return (
        <Modal
            isOpen={isOpen}
            className="orgModal p-0"
            onRequestClose={onRequestClose}
            contentLabel="Organisational Policy Modal"
            ariaHideApp={false}
        >
            <div className="text-center bg-white w-52 m-auto p-4 rounded-4">
                <div style={{ margin: '0 -20px', paddingBottom: '8px', borderBottom: '1px solid #ccc', paddingLeft: '30px', paddingRight: '1px', }}>
                    <img
                        src="/images/close-icon.png"
                        alt="close"
                        style={{
                            height: '18px', width: '18px', cursor: 'pointer', position: 'absolute', top: '15px', right: '15px',
                        }}
                        onClick={onRequestClose}
                    />
                    <div className="align-items-center">
                        <h5 className="fw-bold font-20 mt-0 mb-2">
                            {t('organisation_modal_policy')}
                        </h5>
                    </div>
                </div>

                <div className="pt-4 pb-2">
                    <p className="m-0 font-16">
                        Organisation policy upload is pending<br /> from the admin’s side.
                    </p>
                </div>
            </div>
        </Modal>
    );
};

export default OrganisationalPolicyModal;
